var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEth = function SvgEth(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0V0C43.464 0 56 12.536 56 28V28C56 43.464 43.464 56 28 56V56C12.536 56 0 43.464 0 28V28Z",
    fill: "#080808",
    fillOpacity: 0.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9967 10L27.7551 10.8204V34.6241L27.9967 34.8651L39.0459 28.3338L27.9967 10Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9968 10L16.9473 28.3338L27.9968 34.8651V23.3114V10Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9967 36.9571L27.8606 37.1231V45.6024L27.9967 45.9997L39.0527 30.4292L27.9967 36.9571Z",
    fill: "#3C3C3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9968 45.9997V36.9571L16.9473 30.4292L27.9968 45.9997Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9968 34.8651L39.046 28.3338L27.9968 23.3114V34.8651Z",
    fill: "#141414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9473 28.3338L27.9968 34.8651V23.3114L16.9473 28.3338Z",
    fill: "#393939"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.5C12.8122 55.5 0.5 43.1878 0.5 28H-0.5C-0.5 43.7401 12.2599 56.5 28 56.5V55.5ZM55.5 28C55.5 43.1878 43.1878 55.5 28 55.5V56.5C43.7401 56.5 56.5 43.7401 56.5 28H55.5ZM28 0.5C43.1878 0.5 55.5 12.8122 55.5 28H56.5C56.5 12.2599 43.7401 -0.5 28 -0.5V0.5ZM28 -0.5C12.2599 -0.5 -0.5 12.2599 -0.5 28H0.5C0.5 12.8122 12.8122 0.5 28 0.5V-0.5Z",
    fill: "#080808",
    fillOpacity: 0.08
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ETH.25191cd0006f70ba27dd15df26ec168d.svg";